import { graphql, useStaticQuery } from "gatsby"

export const useAllTemplateTypes = () => {
  const data = useStaticQuery(graphql`
    {
      allContentfulTemplate(filter: { title: { ne: "__schema__" } }) {
        nodes {
          type
        }
      }
    }
  `)

  const templateTypes = new Set()
  data.allContentfulTemplate.nodes.forEach(node => {
    node.type.forEach(type => {
      templateTypes.add(type)
    })
  })

  return [...templateTypes].sort()
}
